<template v-slot:item.isPublished="{ item }">
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        small
        :color="getColor(item.isPublished)"
      >
      </v-chip>
    </template>
    <span> {{ fillToolTips(item.isPublished) }} </span>
  </v-tooltip>
</template>
<script>
import TooltipsData from "@/services/lableTooltips.js";
export default {
  name: "publishedStatusChip",
  props: ["item"],
  data() {
    return {};
  },
  methods:{
    fillToolTips(isPublised) {
      if(isPublised) return TooltipsData.methods.getTooltips("published");
      else return  TooltipsData.methods.getTooltips("unPublished");
    },
    getColor(Status) {
    if (Status === false) return "red";
    else return "green";
    },
  }
};
</script>